import React from 'react';
import QRCode from 'qrcode.react';
import {Button, Modal, ModalBody, ModalHeader} from 'reactstrap';
import translate from '../../../helpers/LanguageModel';
import './qrCodeModal.css';

const QrCodeModal = props => {
    return (
        <Modal className="qrCode-modal" isOpen={props.isQrModalShown} toggle={props.toggle}>
            <ModalHeader>{translate('QR_CODE')}</ModalHeader>
            <ModalBody>
                <div className="qrCode">
                    <QRCode value={props.package && props.package.code ? props.package.code : ''} />
                </div>
                <Button color="secondary" className="ml-1 qrCode-btn" onClick={() => props.toggle()}>
                    {translate('CLOSE')}
                </Button>
            </ModalBody>
        </Modal>
    )
};

export default QrCodeModal;



// WEBPACK FOOTER //
// ./src/components/Person/QrCodeModal/QrCodeModal.js